import { Vector3, DoubleSide, Euler } from 'three';
import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Floor extends Component{
  render() {
    const rotation = new Euler(Math.PI/2, 0, 0);
    const { position } = this.props;
    return (
      <mesh key={'floor'}
        position={ position }
        rotation={rotation}
        >
        <planeBufferGeometry
          width={400}
          height={400}
          widthSegments={30}
          heightSegments={30}
        />
        <meshBasicMaterial
          opacity={0.5}
          color={0x333000}
          side={ DoubleSide }
          wireframe
        />
      </mesh>
    )
  }
}

Floor.defaultProps = {
  position: new Vector3(),
}

Floor.propTypes = {
  position: PropTypes.instanceOf(Vector3),
}

export default Floor;



// WEBPACK FOOTER //
// ./src/components/common/materials/Floor.js